import React, { Component } from "react";
import { Box, Button, Container, Grid, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { navigate } from "gatsby-link";
import TextTransition, { presets } from "react-text-transition";
import Footer from "../utils/Footer";
import EventNoteIcon from "@material-ui/icons/EventNote";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import MessageIcon from "@material-ui/icons/Message";
import HeroImage from "./heroImage";
import Features from "./features";
import withWidth from "@material-ui/core/withWidth";

const TEXTS = [
  "Chcesz zapobiec wykorzystaniu Twojej aplikacji przez oszustów?",
  "Jesteś zobowiązany do identyfikacji klientów wymogami prawa?",
  "Chcesz obsługiwać tylko sprawdzonych, nieanonimowych użytkowników?",
];

const howItWorks = {
  title: "Jak to działa",
  subtitle:
    "Proces weryfikacji tożsamości Twoich użytkowników w 6 prostych krokach",
  items: [
    {
      name: "Zlecenie weryfikacji",
      text:
        "Twoja aplikacja tworzy zlecenie potwierdzenia tożsamości użytkownika via API FiberID",
    },
    {
      name: "Przekierowanie do FiberID",
      text:
        "Twoja aplikacja przekierowuje użytkownika do FiberID w celu dokonania weryfikacji",
    },
    {
      name: "Ankieta użytkownika",
      text:
        "Użytkownik podaje swoje dane - listę wymaganych informacji ustalasz w specyfikacji zlecenia",
    },
    {
      name: "Uzyskanie danych użytkownika",
      text:
        "Użytkownik udostępnia swoje dane - udzielając zgody na dostęp do konta bankowego, wykonując przelew weryfikacyjny lub podpisując formularz swoim Profilem Zaufanym",
    },
    {
      name: "Potwierdzenie zgodności",
      text:
        "FiberID porównuje dane, które użytkownik podał w ankiecie z uzyskanymi z wiarygodnego źródła - konta lub przelewu bankowego, Pofilu Zaufanego",
    },
    {
      name: "Przekazanie wyników",
      text:
        "Twoja aplikacja otrzymuje wynik potwierdzenia tożsamości wraz danymi, które użytkownik podał w ankiecie FiberID",
    },
  ],
};

const verificationMethods = {
  title: "Mechanizmy weryfikacji",
  subtitle:
    "Wybierz spośród dostępnych sposobów sprawdzenia tożsamości użytkownika",
  items: [
    {
      name: "Dane konta bankowego",
      text:
        "Po zalogowaniu się użytkownika do konta bankowego potwierdzimy zgodność podanych przez użytkownika danych z imieniem i nazwiskiem właściciela konta",
      icon: <MessageIcon fontSize="large" />,
    },
    {
      name: "Przelew weryfikacyjny",
      text:
        "Po przelewie niewielkiej kwoty na nasze konto potwierdzimy zgodność danych użytkownika z imieniem i nazwiskiem nadawcy przelewu",
      icon: <MonetizationOnIcon fontSize="large" />,
    },
    {
      name: "Profil Zaufany",
      text:
        "Po zalogowaniu się użytkownika do Profilu Zaufanego (ePUAP) zweryfikujemy zgodność danych użytkownika z imieniem i nazwiskiem właściciela Profilu",
      icon: <EventNoteIcon fontSize="large" />,
    },
  ],
};

const styles = theme => ({
  bold: {
    color: theme.palette.common.black,
    fontWeight: "500",
    align: "center",
  },
  boldWhite: {
    color: theme.palette.common.white,
    fontWeight: "600",
  },
  textSection: {
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(8),
      marginLeft: theme.spacing(8),
      marginRight: theme.spacing(8),
    },
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  textTransition: {
    fontWeight: "700",
    color: theme.palette.secondary.white,
    display: "flex",
    // justifyContent: "space-around",
  },
  sectionThree: {
    color: theme.palette.common.black,
    fontWeight: "bold",
  },
  sectionFive: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    background: "linear-gradient(10deg, #3180de, #1e5abb, #69b3e6)",
    color: "white",
    textAlign: "center",
  },
  sectionFiveContent: {
    display: "flex",
    justifyContent: "space-between",
  },
  contactButton: {
    height: theme.spacing(8),
    borderRadius: theme.spacing(4),
    color: "white",
    fontSize: theme.spacing(2),
  },
  center: {
    margin: "auto",
    padding: theme.spacing(2),
  },
});

class Landing extends Component {
  state = {
    index: 0,
  };

  componentDidMount() {
    this.handler = setInterval(() => {
      this.setState({ index: this.state.index + 1 });
    }, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.handler);
  }

  render() {
    const { classes } = this.props;

    return (
      <>
        <HeroImage />
        <Box className={classes.sectionThree} py={4}>
          <Container component="section">
            <Box className={classes.textSection} align="center">
              <Typography variant="h5" paragraph className={classes.bold}>
                <TextTransition
                  className={classes.textTransition}
                  text={TEXTS[this.state.index % (TEXTS.length)]}
                  springConfig={presets.woobly}
                  inline={this.props.width !== "sm" && this.props.width !== "xs"}
                />
              </Typography>
            </Box>
          </Container>
        </Box>
        {/* <p>{`current width: ${this.props.width}`}</p>
        <p>{(this.props.width !== "sm" && this.props.width !== "xs") ? "true" : "false"}</p> */}
        <Features
          title={howItWorks.title}
          subtitle={howItWorks.subtitle}
          items={howItWorks.items}
        />

        <Features
          title={verificationMethods.title}
          subtitle={verificationMethods.subtitle}
          items={verificationMethods.items}
        />

        <Box className={classes.sectionFive}>
          <Container
            container
            spacing={4}
            className={classes.sectionFiveContent}
            component="section"
          >
            <Grid container justifyContent="space-between">
              <Grid item>
                <Box align="left">
                  <Typography variant="h2" className={classes.boldWhite}>
                    Potwierdź tożsamość klienta
                  </Typography>
                  <Typography variant="h5">
                    ...zanim obsłużysz jego transakcje lub udzielisz mu dostępu
                    do swoich zasobów i usług
                  </Typography>
                </Box>
              </Grid>
              <Grid item >
                <Box align="left" py={2}>
                  <Button
                    className={classes.contactButton}
                    variant="contained"
                    onClick={() => navigate("/register")}
                    disableElevation
                    color="secondary"
                  >
                    Wypróbuj
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Footer />
      </>
    );
  }
}

// export default withStyles(styles)(Landing);
export default withWidth()(withStyles(styles)(Landing));
